export default values => ({
  commercialName: values.commercialName ?? '',
  equipmentType: values.equipmentType ?? ''
});
